var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.7 471.7",
    style: {
      enableBackground: "new 0 0 471.7 471.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423.1,74.8c-24.5-24.5-57-38-91.7-38s-67.2,13.5-91.8,38l-3.7,3.7l-3.9-3.9c-24.6-24.6-57.2-38.1-91.9-38.1 c-34.6,0-67.1,13.5-91.6,38c-24.6,24.6-38,57.2-38,91.8c0,34.5,13.5,67.1,38.1,91.7l170.3,170.3c4.4,4.4,10.5,6.9,16.6,6.9 c6.2,0,12.3-2.5,16.6-6.8l170.6-170c24.5-24.5,38-57.1,38-91.7C461.1,131.9,447.7,99.3,423.1,74.8z M389.7,225l-154,153.4 L82.1,224.7c-15.6-15.6-24.2-36.4-24.2-58.4c0-22.1,8.6-42.8,24.1-58.3c15.6-15.6,36.3-24.2,58.3-24.2c22.1,0,42.9,8.6,58.5,24.2 l20.5,20.5c9.2,9.2,24.1,9.2,33.3,0l20.3-20.3C288.6,92.6,309.3,84,331.4,84c22,0,42.7,8.6,58.3,24.2c15.6,15.6,24.1,36.3,24.1,58.5 C413.9,188.6,405.4,209.3,389.7,225z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoFavorite);
export default __webpack_public_path__ + "static/media/picto-favorite.8858070d.svg";
export { ForwardRef as ReactComponent };